import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          header: {
            nav: {
              tutorials: 'Tutorials',
              workshops: 'Workshops',
              shop: 'Shop',
              about: 'About',
              contact: 'Contact'
            },
            logo: 'Inbal Art Makers',
            search: 'Search',
            cart: 'Shopping Cart',
            language: 'Language'
          },
          banner: {
            title: 'Welcome to Inbal Art Makers',
            subtitle: 'Discover the art of handmade jewelry',
            cta: 'Shop Now'
          },
          homepage: {
            hero: {
              title: 'Handcrafted Jewelry',
              subtitle: 'Unique pieces made with love',
              cta: 'Explore Collection'
            },
            featured: {
              title: 'Featured Products',
              subtitle: 'Discover our latest creations'
            }
          },
          shop: {
            title: 'Our Shop',
            subtitle: 'Browse our collection of handmade jewelry'
          },
          tutorials: {
            title: 'Tutorials',
            subtitle: 'Learn how to create beautiful jewelry'
          },
          workshops: {
            title: 'Workshops',
            subtitle: 'Join our jewelry making workshops'
          },
          about: {
            title: 'About Us',
            subtitle: 'Our story and mission'
          },
          contact: {
            title: 'Contact Us',
            subtitle: 'Get in touch with us'
          }
        }
      },
      he: {
        translation: {
          header: {
            nav: {
              tutorials: 'הדרכות',
              workshops: 'סדנאות',
              shop: 'חנות',
              about: 'אודות',
              contact: 'צור קשר'
            },
            logo: 'הסדנה של ענבל',
            search: 'חיפוש',
            cart: 'עגלת קניות',
            language: 'שפה'
          },
          banner: {
            title: 'ברוכים הבאים לסדנא של ענבל',
            subtitle: 'גלו את אמנות התכשיטים הידנית',
            cta: 'קנו עכשיו'
          },
          homepage: {
            hero: {
              title: 'תכשיטים בעבודת יד',
              subtitle: 'יצירות ייחודיות מעוצבות באהבה',
              cta: 'גלו את הקולקציה'
            },
            featured: {
              title: 'מוצרים מומלצים',
              subtitle: 'גלו את היצירות החדשות שלנו'
            }
          },
          shop: {
            title: 'החנות שלנו',
            subtitle: 'עיינו בקולקציית התכשיטים בעבודת יד שלנו'
          },
          tutorials: {
            title: 'מדריכים',
            subtitle: 'למדו כיצד ליצור תכשיטים יפים'
          },
          workshops: {
            title: 'סדנאות',
            subtitle: 'הצטרפו לסדנאות יצירת התכשיטים שלנו'
          },
          about: {
            title: 'אודותינו',
            subtitle: 'הסיפור והמשימה שלנו'
          },
          contact: {
            title: 'צור קשר',
            subtitle: 'צרו איתנו קשר'
          }
        }
      }
    },
    lng: 'he',
    fallbackLng: 'he',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 